@if (control()) {
  <div class="input-keyword">
    <procure-input-select
      class="input-keyword__select"
      hint="You can select from existing keywords or add new ones by entering text and pressing the Enter or Tab key."
      [label]="label()"
      [control]="control()"
      [addable]="addable()"
      [multiple]="true"
      [showMode]="showMode()"
      [items]="keywords()"
      [id]="id()"
      (changed)="onChange()"
    />
  </div>
}
